export const SELECT_MENU_ITEM = 'select_menu_item'
export const TOGGLE_MENU = 'toggle_menu'

export function selectItem(item, scroll) {
  return {
    type: SELECT_MENU_ITEM,
    payload: {
      currentItem: item,
      scroll
    }
  };
}
export function toggleMenu() {
  return {
    type: TOGGLE_MENU
  };
}


// WEBPACK FOOTER //
// ./src/actions/index.js